// import 'mtui/style.css';
// import 'antd/dist/antd.css';
import styles from './frame.scss';
import React, { Component } from 'react';
import classNames from 'classnames';
// import Footer from '../footer/Footer';
import Header from '../header/Header';
// import Loading from '../../components/loading/Loading';

/**
 * @desc 页面整体框架组件
 */
export default class Frame extends Component {
    render() {
        return (
            <div className={styles.frame}>
                <div className={styles.wrapper}>
                    <Header />
                    <div className={classNames(styles.container, 'clearfix')}>
                        {this.props.children}
                    </div>
                    {/* <Footer /> */}
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/layouts/frame/Frame.jsx